import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import Input from '../../Input';
import { getLocale } from '../../locale';
import ConfigConsumer from '../../ConfigConsumer';

var QuickJumper = /*#__PURE__*/function (_React$Component) {
  _inherits(QuickJumper, _React$Component);

  var _super = _createSuper(QuickJumper);

  function QuickJumper(props) {
    var _this;

    _classCallCheck(this, QuickJumper);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (value) {
      // 只能输入数字
      value = value.replace(/\D/g, '').trim();
      value = value === '' ? '' : Number(value);

      _this.setState({
        value: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInputBlur", function () {
      var value = _this.state.value;
      var _this$props = _this.props,
          max = _this$props.max,
          onChange = _this$props.onChange; // 点击enter键，不用取消focus状态

      if (value === '') return;
      if (value > max) value = max;
      if (value < 1) value = 1;

      _this.setState({
        value: value
      });

      onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      if (e.keyCode === 13) _this.onInputBlur('keyDown');
    });

    _this.state = {
      value: ''
    };
    return _this;
  }

  _createClass(QuickJumper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var size = this.props.size;
      var value = this.state.value;
      return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref) {
        var locale = _ref.locale;
        return /*#__PURE__*/React.createElement("div", {
          className: "jmtd-pagination-jump"
        }, /*#__PURE__*/React.createElement("span", {
          className: "jmtd-pagination-jump-text jmtd-pagination-jump-prefix"
        }, getLocale(locale).pagination.goto), /*#__PURE__*/React.createElement(Input, {
          placeholder: "",
          allowClear: false,
          width: 53,
          className: "jmtd-pagination-jump-input",
          size: size,
          value: value,
          onChange: function onChange(e) {
            return _this2.onInputChange(e);
          },
          onFocus: _this2.onInputFocus,
          onBlur: _this2.onInputBlur,
          onKeyDown: _this2.onKeyDown
        }), /*#__PURE__*/React.createElement("span", {
          className: "jmtd-pagination-jump-text jmtd-pagination-jump-suffix"
        }, getLocale(locale).pagination.gotoPage));
      });
    }
  }]);

  return QuickJumper;
}(React.Component);

QuickJumper.propTypes = {
  size: PropTypes.oneOf(['mini', 'small', 'middle', 'large']),
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};
QuickJumper.defaultProps = {
  size: null
};
export default QuickJumper;